import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";

var _templateObject = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n"]);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import { createMuiTheme } from "@material-ui/core";
import { css } from "@emotion/core";
export var theme = {
  typography: {
    fontFamily: "Avenir Next, sans-serif;"
  }
};
export var muiTheme = createMuiTheme(theme);
export var palette = {
  white: "#FFF",
  grayLight: "#EEEEEE",
  gray60: "#999",
  gray70: "#666",
  pink: "#FFDFDF",
  black: "#000000",
  black2: "#333"
};
export var arrowGenerator = function arrowGenerator() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#fff";
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.95em",
      width: "2em",
      height: "1em",
      boxShadow: "-2px -2px 5px rgba(0,0,0,0.06)",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: "transparent transparent " + color + " transparent"
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-0.95em",
      width: "2em",
      height: "1em",
      boxShadow: "3px 3px 7px rgba(0,0,0,0.07)",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: color + " transparent transparent transparent"
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: "-0.95em",
      height: "2em",
      width: "1em",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: "transparent " + color + " transparent transparent"
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: "-0.95em",
      height: "2em",
      width: "1em",
      boxShadow: "3px -3px 7px rgba(0,0,0,0.07)",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: "transparent transparent transparent " + color
      }
    }
  };
};
export var commonArrowStyles = {
  position: "absolute",
  fontSize: 6,
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: 0,
    height: 0,
    borderStyle: "solid"
  }
};
export var selectOptionsColors = {
  DARK_VANILLA: "#D2CCA1",
  PASTEL_PINK: "#D6A2AD",
  ICEBERG: "#74B3CE",
  GREEN_1: "#C8D5B9",
  BURLYWOOD: "#D6BA73",
  GREEN_2: "#8FC0A9",
  MOUNTBATTEN_PINK: "#9E7B9B",
  PAYNES_GREY: "#616283",
  STEEL_TEAL: "#50808E",
  GREEN_3: "#68B0AB",
  UNKNOWN: "#696D7D"
};
var selectOptionsColorsAsArray = Object.entries(selectOptionsColors);
export var getSelectOptionColorByIndex = function getSelectOptionColorByIndex(index) {
  var _ref;

  var justColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _selectOptionsColorsA = selectOptionsColorsAsArray[index % selectOptionsColorsAsArray.length],
      key = _selectOptionsColorsA[0],
      value = _selectOptionsColorsA[1];

  if (justColor) {
    return value;
  }

  return _ref = {}, _ref[key] = value, _ref;
};
export var darkButtonStyles = css(_templateObject, palette.white, palette.black2, palette.gray70);